import { addCancelButtonToForm } from '../util/helpers';

export default {
  init() {
    // scripts here run on the DOM load event
    addCancelButtonToForm();
  },
  finalize() {
    // scripts here fire after init() runs
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js